async function appConfig(to, from, next) {
  try{
    /** Now uses this global function to ensure data is loaded */
    await Vue.store.dispatch('appConfig/loadBasicData', {
      routeMunicipalityName: to.params.municipality
    })
  } catch (err) {
    console.error('Error in appConfig guard:', err)
  }
  
  next()
}

export default appConfig
